import { useState, useEffect } from "react";

interface CurrentTime {
  hours: string;
  minutes: string;
  seconds: string;
  day: string;
  month: string;
  year: string;
  formattedTime: string;
  formattedDate: string;
  dateObj: Date;
}

export const useCurrentTime = (intervalMs: number = 1000) => {
  const [currentTime, setCurrentTime] = useState<CurrentTime>(() => {
    const now = new Date();
    return formatDate(now);
  });

  useEffect(() => {
    const updateTime = () => setCurrentTime(formatDate(new Date()));

    updateTime(); // initialize immediately
    const interval = setInterval(updateTime, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs]);

  return { currentTime };
};

function formatDate(now: Date): CurrentTime {
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = String(now.getFullYear());

  return {
    hours,
    minutes,
    seconds,
    day,
    month,
    year,
    formattedTime: `${hours}:${minutes}:${seconds}`,
    formattedDate: `${day}/${month}/${year}`,
    dateObj: now,
  };
}
